<template>
<div>
  <v-app-bar color="blue accent-1" >
      <v-app-bar-nav-icon color="white" @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">Hana's English</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn outlined small>Login</v-btn> -->
  </v-app-bar>
    <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    >
      <sideBar @setSubCategory="setSubCategory"/>
    </v-navigation-drawer>
  <v-container>
     <v-card class="pa-2">
      <v-card-title>
        교육일정
      </v-card-title>
      <v-divider class="mx-2" />
      
      <!--달력 start-->
      <v-row class="fill-height">
        <v-col>
          <!--달력 상단 start-->
          <v-sheet height="64">
            <v-toolbar flat>
              <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
              >
                Today
              </v-btn>
              <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="prev"
              >
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="next"
              >
                <v-icon small>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <v-menu
                bottom
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="grey darken-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>4 days</v-list-item-title>
                  </v-list-item>
                </v-list>
            </v-menu> -->
            </v-toolbar>
          </v-sheet>
          <!--달력 상단 end-->
          <!--달력 하단 start-->
          <v-sheet height="600">
           <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              :events="events"
	      @click:event="showEventDetails"
            ></v-calendar>
          </v-sheet>
          <!--달력 하단 end-->
        </v-col>
      </v-row>
      <!--달력 end-->
     </v-card>
  </v-container>
    <v-dialog v-model="showModal" max-width="600px">
      <v-card>
        <v-card-title>{{ selectedEvent.name }}</v-card-title>
	<v-divider />
        <v-card-text>
          <!-- 여기에 이벤트의 상세 정보를 표시하는 내용을 추가하세요 -->
          {{ selectedEvent.description }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="grey"block outlined @click="showModal = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
  import sideBar from '@/components/sideBar.vue'
  import axios from 'axios'

  export default {
    data: () => ({
      drawer: false,
      show_post_view: false,
      page: 1,

      category_title: 'Total',
      sub_category : {},
      sub_category_id : 0,

      focus: '',
      // type: 'month',
      // types: ['month', 'week', 'day', '4day'],
      mode: 'stack',
      modes: ['stack', 'column'],
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },

      events: [],
      showModal: false,
      selectedEvent: {},
      }),
    components: {
      sideBar,
    },

    mounted(){
      this.getCalendarEvent()
    },
    methods:{
    	showEventDetails(event) {	
      	this.selectedEvent = event.eventParsed.input;
      	this.showModal = true;
      },
      setSubCategory(sub_category){
        this.drawer = false
        this.sub_category = sub_category
        this.sub_category_id = sub_category.id
        this.category_title = sub_category.name
      },

      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      getCalendarEvent(){
        axios
        .get('api/userinfor/calendar-event/')
        .then(res=>{
          this.events = res.data
        })
      },
      formatDate(dateTimeString) {
          if(dateTimeString==null){
          } else {
              const dateTime = new Date(dateTimeString);
              // const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              const options = { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              return dateTime.toLocaleString(undefined, options);
          }
	      },  
      },
      computed:{
        formattedDateTimes() {
          return this.dateTimeStrings.map((dateTimeString) => this.formatDate(dateTimeString));
          },
      }
  }
</script>
